// ----------------------------------------------------------------------

const account = {
	displayName: "Super Admin",
	email: "demo@minimals.cc",
	photoURL: "/assets/images/avatars/avatar_default.jpg",
};

export default account;
